import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../../auth";

const PublicRoute = ({ component: Component, ...rest }) => {
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      render={props =>
        user ? <Redirect to="/devices" /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
